import { render, staticRenderFns } from "./ModalSosmed.vue?vue&type=template&id=2b842edd&scoped=true&"
import script from "./ModalSosmed.vue?vue&type=script&lang=js&"
export * from "./ModalSosmed.vue?vue&type=script&lang=js&"
import style0 from "./ModalSosmed.vue?vue&type=style&index=0&id=2b842edd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b842edd",
  null
  
)

export default component.exports